import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
  Input,
  FormGroup,
  Form,
  Label,
} from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

import { useDispatch } from "react-redux";
import { addLocation, updateLocation } from "../../../store/locations/actions";

const schema = yup.object().shape({
  title: yup.string().max(100).required(),
  titlear: yup.string().max(100).required(),
  longitude: yup.number().required(),
  latitude: yup.number().required(),
});

export default function AddLocation({
  modal_center,
  tog_center,
  setmodal_center,
  data,
}) {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      title: data.title,
      titlear: data.titlear,
      description: data.description,
      longitude: data.longitude,
      latitude: data.latitude,
    },
  });

  const onSubmit = (formData) => {
    console.log("gggg");
    if (Object.keys(data).length !== 0) {
      // let data = data.append("image", files);
      dispatch(updateLocation({ ...formData, id: data.id }));
    } else {
      // let data = data.append("image", files);
      dispatch(addLocation({ ...formData }));
    }
    if (!Object.keys(errors).length) {
      //   reset();
      setmodal_center(false);
    }
  };

  return (
    <Modal
      isOpen={modal_center}
      toggle={() => {
        tog_center();
      }}
      centered
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          style={{ display: "flex", alignItems: "center" }}
        >
          <i class="ri-add-circle-line" style={{ paddingRight: 5 }}></i>{" "}
          {Object.keys(data).length !== 0 ? "Update" : "Add"} Add New Location
        </h5>
        <button
          type="button"
          onClick={() => {
            setmodal_center(false);
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md="12">
              <div className="field mb-3">
                <input
                  className={`form-control ${
                    errors.title ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="text"
                  {...register("title")}
                />
                <span class="label">Title</span>
              </div>
            </Col>
            <Col md="12">
              <div className="field mb-3">
                <input
                  className={`form-control ${
                    errors.titlear ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="text"
                  {...register("titlear")}
                />
                <span class="label">Arabic Title</span>
              </div>
            </Col>
            {/* <Col md="12">
              <div className="field  mb-3">
                <textarea
                  className={`form-control ${
                    errors.description ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="date"
                  {...register("description")}
                ></textarea>
                <span class="label">Description</span>
              </div>
            </Col> */}
            <Col md="12">
              <div className="field mb-3">
                <input
                  className={`form-control ${
                    errors.latitude ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="number"
                  step="any"
                  {...register("latitude")}
                />
                <span class="label">Latitude</span>
              </div>
            </Col>
            <Col md="12">
              <div className="field mb-3">
                <input
                  className={`form-control ${
                    errors.longitude ? "is-invalid" : null
                  }`}
                  placeholder=""
                  step="any"
                  type="number"
                  {...register("longitude")}
                />
                <span class="label">Longitude</span>
              </div>
            </Col>
          </Row>

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-lg btn-secondary"
              onClick={() => {
                setmodal_center(false);
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              //   onClick={() => {
              //     setmodal_center(false);
              //   }}
              className="btn btn-lg btn-primary"
            >
              {Object.keys(data).length !== 0 ? "Update" : "Add New"}
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
